export default __webpack_public_path__ + "static/media/cv.981ba3bb.jpg";